import { render, staticRenderFns } from "./personagePage.vue?vue&type=template&id=7e7b2fde&scoped=true"
import script from "./personagePage.vue?vue&type=script&lang=js"
export * from "./personagePage.vue?vue&type=script&lang=js"
import style0 from "./personagePage.vue?vue&type=style&index=0&id=7e7b2fde&prod&lang=scss&scoped=true"
import style1 from "./personagePage.vue?vue&type=style&index=1&id=7e7b2fde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7b2fde",
  null
  
)

export default component.exports